<template>
  <section v-if="data" :class="$style.root">
    <div :class="$style.content">
      <pagesExhibitionsSlugComponent :data="data" />
    </div>

    <LayoutPrevNextPageComponent
      :prev="getAttributes(prev)"
      :next="getAttributes(next)"
    />
  </section>
  <SharedErrorComponent v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
const route = useRoute()

const getAttributes = baseStrapiGetAttributes

// 1
useHead({
  htmlAttrs: { 'data-page-type': 'exhibitions' }
})

// 2
const { data, error } = await useAsyncData(`exhibitions-slug-${route.params.slug}`, () =>
  fetchQueryPath( queryExhibitionEntryBySlug(baseStrapiGetSlugQueryObjectFromRoute()) )
)

const attributes = baseStrapiGetAttributes(data)
const defaultOgImageUrl = baseStrapiGetAbsoluteFileUrl(attributes?.coverImage?.data?.attributes?.url, attributes?.coverImage?.data?.provider)
basePageSetHead(data, defaultOgImageUrl)

// 3
const prevQueryOptions = baseStrapiGetPrevNextQueryObject(getAttributes(data)?.dateStart, '$lt', 'desc')
const { data: prev } = await useAsyncData(`exhibitions-slug-prev-${route.params.slug}`, () =>
  fetchQueryPath( queryExhibitionEntryPrevNextBySlug(prevQueryOptions) )
)

const nextQueryOptions = baseStrapiGetPrevNextQueryObject(getAttributes(data)?.dateStart, '$gt', 'asc')
const { data: next } = await useAsyncData(`exhibitions-slug-next-${route.params.slug}`, () =>
  fetchQueryPath( queryExhibitionEntryPrevNextBySlug(nextQueryOptions) )
)
</script>

<style module>
.root {
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
}
</style>
